import type { ICustomControlDiagnosticReportReadProps } from '../../interfaces/customControlDiagnosticReportReadProps';

export function OsasqV1DiagnosticReportRead(props: ICustomControlDiagnosticReportReadProps) {
    return null;
}
